<template>
  <div class="card">
    <div class="card-header pb-0">
      <!-- <h6>Data Jemaat</h6> -->
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="row p-3">
        <div class="col-12 col-md-auto mb-3" v-if="user.role == 1">
          <argon-button size="sm" full-width @click="addData()">Tambah Data</argon-button>
        </div>
        <div class="col-md-12">
          <argon-input type="text" placeholder="Pencarian" v-model:value="search" name="search" size="lg" />
        </div>
        <div class="col-md-6" v-if="user.role == 1">
            <label for="example-text-input" class="form-control-label"
              >Wilayah</label
            >
            <VueMultiselect
              v-model="search_wilayah"
              :options="wilayah"
              :multiple="false"
              :close-on-select="true"
              placeholder="Pilih"
              label="wilayah"
              track-by="wilayah"
            />
        </div>
        <div class="col-md-6" v-if="user.role == 1 || user.role == 2">
          <label for="example-text-input" class="form-control-label"
            >Sektor</label
          >
          <VueMultiselect
            v-model="search_sektor"
            :options="filtered_sektor"
            :multiple="false"
            :close-on-select="true"
            placeholder="Pilih"
            label="nama"
            track-by="nama"
          />
        </div>
      </div>
      <div class="table-responsive p-2">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID Keluarga</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nomor Keluarga</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nama Keluarga</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Alamat</th>
              <!-- <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Telp / HP</th> -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr :key="item.id" v-for="item in items">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column">
                    <h6 class="mb-0 text-sm">{{item.ID_KELUARGA}}</h6>
                  </div>
                </div>
              </td>
              <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.nomor_kk}}</h6>
              </td>
              <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.NAMA_KELUARGA}}</h6>
              </td>
              <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.ALAMAT}}</h6>
              </td>
              <!-- <td>
                <h6 class="text-xs font-weight-bold mb-0">{{item.TELP}}</h6>
              </td> -->
              <td>
                <argon-button v-if="user.role == 1" variant="outline" style="margin-right:10px" size="sm" @click="editData(item.ID)">Edit</argon-button>
                <argon-button v-if="user.role != 1" variant="outline" style="margin-right:10px" size="sm" @click="viewData(item.ID)">Lihat</argon-button>
                <argon-button variant="outline" style="margin-right:10px" size="sm" @click="getAnggota(item.ID_KELUARGA)">Anggota</argon-button>
                <argon-button v-if="user.role == 1" variant="outline" size="sm" @click="deleteData(item.ID)">Delete</argon-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <v-pagination
          v-model="page"
          :pages="maxPage"
          :range-size="1"
          active-color="#DCEDFF"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from "lodash.debounce";
  import ArgonButton from "@/components/ArgonButton.vue";
  import VPagination from "@hennge/vue3-pagination";
  import "@hennge/vue3-pagination/dist/vue3-pagination.css";
  import ArgonInput from "@/components/ArgonInput.vue";
  import VueMultiselect from "vue-multiselect";
  export default {
    name: "keluarga-table",
    components: {
      ArgonButton,
      ArgonInput,
      VueMultiselect,
      VPagination
    },
    beforeUnmount() {
      this.debouncedWatch.cancel();
    },
    created() {
      this.debouncedWatch = debounce(() => {
        let wil = this.search_wilayah
        let wil_id = (!wil) ? wil = "" : wil.id;
        let sek = this.search_sektor
        let sek_id = (!sek) ? sek = "" : sek.id;
        let stat = this.search_status
        let stat_id = (!stat) ? stat = "" : stat.id;
        this.axios.get(process.env.VUE_APP_API_URL + "keluarga?search="+this.search+"&wilayah="+wil_id+"&sektor="+sek_id+"&status="+stat_id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          console.log(resp)
          this.page = resp.data.data.current_page
          this.maxPage = resp.data.data.last_page
          this.items = resp.data.data.data
        })
      }, 500);
    },
    computed: {
      filtered_sektor() {
        if (!this.search_wilayah || !this.search_wilayah.id) return this.sektor;
        return this.sektor.filter(s => s.id_wilayah === this.search_wilayah.id);
      }
    },
    watch: {
      page(newValue){
        console.log(newValue)
        let wil = this.search_wilayah
        let wil_id = (!wil) ? wil = "" : wil.id;
        let sek = this.search_sektor
        let sek_id = (!sek) ? sek = "" : sek.id;
        this.axios.get(process.env.VUE_APP_API_URL + "keluarga?search="+this.search+"&page="+this.page+"&wilayah="+wil_id+"&sektor="+sek_id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          console.log(resp)
          this.page = resp.data.data.current_page
          this.maxPage = resp.data.data.last_page
          this.items = resp.data.data.data
        })
      },
      search(newVal){
        this.debouncedWatch(newVal);
      },
      search_wilayah(newVal, oldVal){
        if (oldVal && newVal && oldVal.id !== newVal.id) {
          this.search_sektor = '';
        }
        this.debouncedWatch(newVal);
      },
      search_sektor(newVal){
        this.debouncedWatch(newVal);
      },
    },
    methods: {
      getWilayah(value) {
        if (value == 0 || value == null) return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.wilayah.filter(x => x.id == value)))[0].wilayah
      },
      getSektor(value) {
        if (value == 0 || value == null) return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.sektor.filter(x => x.id == value)))[0].nama
      },
      getStatus(value) {
        if (value == "0" || value == null || value == '') return 'Belum Terisi'
        return JSON.parse(JSON.stringify(this.status.filter(x => x.id == value)))[0].nama
      },
      roundUpNearest10(num) {
        return Math.ceil(num / 10) * 10;
      },
      roundDownNearest10(num) {
        return Math.ceil(num / 10) * 10;
      },
      addData(){
        this.$router.push("/data-keluarga/add")
      },
      viewData(id){
        this.$router.push({
          name: "View Data Keluarga",
          params: { id: id },
        })
      },
      editData(id){
        this.$router.push({
          name: "Edit Data Keluarga", 
          params: { id: id }, 
        })
      },
      getAnggota(id){
        this.$router.push({
          name: "Anggota Keluarga", 
          params: { id: id }, 
        })
      },
      deleteData(id){
        this.axios.delete(process.env.VUE_APP_API_URL + "keluarga/"+id, {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          console.log(resp)
          this.$toast.open({
            message: 'Data Terhapus!',
            type: 'success',
          });
          this.axios.get(process.env.VUE_APP_API_URL + "keluarga", {headers: {
            "Authorization": "Bearer " + localStorage.getItem("token")
          }}).then((resp) => {
            this.page = resp.data.data.current_page
            this.maxPage = resp.data.data.last_page
            this.items = resp.data.data.data
          })
        })
      },
    },
    data() {
      return {
        items: '',
        sektor: '',
        wilayah: '',
        status: '',
        page: 1,
        maxPage: 1,
        search: '',
        search_wilayah: '',
        search_sektor: '',
        user: '',
      }
    },
    mounted(){
      this.axios.get(process.env.VUE_APP_API_URL + "data", {headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }}).then((resp) => {
        this.wilayah = JSON.parse(JSON.stringify(resp.data.wilayah))
        this.sektor = JSON.parse(JSON.stringify(resp.data.sektor))
        this.status = JSON.parse(JSON.stringify(resp.data.status))
        this.axios.get(process.env.VUE_APP_API_URL + "keluarga", {headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        }}).then((resp) => {
          console.log(resp)
          this.user = resp.data.user
          this.page = resp.data.data.current_page
          this.maxPage = resp.data.data.last_page
          this.items = resp.data.data.data

          // Auto-set filters for Ketua roles
          if(this.user.role == 2 && this.user.wilayah_id){
            const wil = this.wilayah.find(w => w.id == this.user.wilayah_id)
            if(wil) this.search_wilayah = wil
          } else if(this.user.role == 3 && this.user.sektor_id){
            const sek = this.sektor.find(s => s.id == this.user.sektor_id)
            if(sek){
              const wil = this.wilayah.find(w => w.id == sek.id_wilayah)
              if(wil) this.search_wilayah = wil
              this.search_sektor = sek
            }
          }
        })
      })
      
    }
  };
</script>
